export default __webpack_public_path__ + "static/media/DENTISTCERTIFICATE_BLANK_EN.b4f03592.png";